import React, { useRef } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { motion, useInView } from "framer-motion";

const About = () => {
  const ref = useRef(null);

  // 👇 detect when About section is visible
  const isInView = useInView(ref, {
    amount: 0.4, // trigger when 40% visible
    once: false, // keep updating on scroll
  });

  return (
    <Box
      ref={ref}
      id="about"
      sx={{
        py: { xs: 10, md: 10 },
        px: { xs: 6, md: 0 },

        // 🎯 dynamic background
        background: isInView
          ? "linear-gradient(135deg, #000000, #1a1a1a)"
          : "#ffffff",

        // 🎯 dynamic text color
        color: isInView ? "#ffffff" : "#000000",

        transition: "all 0.6s ease",

        fontFamily: "'Poppins', 'Inter', sans-serif",
      }}
    >
      <Box maxWidth="1100px" mx="auto">
        
        {/* TITLE */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1 }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              textAlign: "center",
              letterSpacing: 1,
            }}
          >
            About Me
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              color: isInView ? "#cfcfcf" : "#555",
              mt: 1,
              mb: { xs: 4, md: 6 },
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            Full Stack Developer & Accounting / Financial Specialist
          </Typography>
        </motion.div>

        <Grid container spacing={5}>
          
          {/* LEFT SIDE */}
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -60 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: 600, mb: 2, px: { xs: 0, md: 2 } }}
              >
                Who I Am
              </Typography>

              <Typography
                sx={{
                  color: isInView ? "#dcdcdc" : "#333",
                  lineHeight: 1.9,
                  fontSize: "18px",
                  px: { xs: 0, md: 2 },
                }}
              >
                I am a Full Stack Developer specialized in building scalable web
                applications and advanced accounting systems.
                <br /><br />
                I combine software engineering with strong accounting and financial
                knowledge to deliver real business solutions used in ERP systems,
                financial departments, and accounting operations.
              </Typography>
            </motion.div>
          </Grid>

          {/* RIGHT SIDE */}
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 60 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: 600, mb: 2, px: { xs: 0, md: 2 } }}
              >
                Skills & Expertise
              </Typography>

              <Typography
                sx={{
                  color: isInView ? "#dcdcdc" : "#333",
                  lineHeight: 2,
                  fontSize: "18px",
                  px: { xs: 0, md: 2 },
                }}
              >
                💻 <b>Development</b><br />
                React, Node.js, Laravel, SQL Server, APIs
                <br /><br />

                📊 <b>Accounting</b><br />
                Payroll, VAT (TVA), Taxation, Journal Entries, Financial Control
                <br /><br />

                🏢 <b>ERP Systems</b><br />
                ERP workflows, accounting automation, reporting systems
                <br /><br />

                📈 <b>Tools</b><br />
                Advanced Excel, financial analysis, reporting
              </Typography>
            </motion.div>
          </Grid>

        </Grid>
      </Box>
    </Box>
  );
};

export default About;